/**
 *
 * @module configurationClientConfiguration
 *
 */

import Check from 'check-types';
import ConfigurationClientExtrasMap from './configurationClientExtrasMap';
import ServiceClientConfiguration from './serviceClientConfiguration';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    instanceStrict,
    nonEmptyString
} = Check.assert;

/**
 *
 * @class ConfigurationClientConfiguration
 * @extends {ServiceClientConfiguration}
 * @desc A model containing the ConfigurationClient's configuration settings.
 *
 */
export default class ConfigurationClientConfiguration extends ServiceClientConfiguration {

    /**
     *
     * @param {ConfigurationClientExtrasMap} extras
     * @param {String} baseUrl
     * @param {Object} [endpoints={}]
     *
     */
    constructor(extras, baseUrl, endpoints = {}) {

        const errorMessage = {
            ctor: 'ConfigurationClientConfiguration(extras, baseUrl, endpoints)',
            get extras() {
                return `${this.ctor} needs ConfigurationClientExtrasMap instance`;
            },
            get baseUrl() {
                return `${this.ctor} baseUrl should be a String with length`;
            }
        };

        instanceStrict(
            extras,
            ConfigurationClientExtrasMap,
            errorMessage.extras,
            InvalidArgumentException
        );

        nonEmptyString(baseUrl, errorMessage.baseUrl, InvalidArgumentException);

        super(baseUrl, endpoints);

        /**
         *
         * @access public
         * @type {ConfigurationClientExtrasMap}
         * @desc The object containing the list of configuration host names and corresponding baseUrls
         *
         */
        this.extras = extras;

    }
}



// WEBPACK FOOTER //
// ./src/services/configuration/configurationClientConfiguration.js